import React, { useState, useEffect } from 'react';
import '../../components/ProductDetail/ProductDetail.css';
import { useParams } from 'react-router-dom';
import { FaArrowRight } from "react-icons/fa";
import { getProductDetails } from '../../API/Api';

const ProductDetail = () => {
  const { slug } = useParams(); // Changed from productId to slug to match API
  
  const [quantity, setQuantity] = useState(1);
  const [activeTab, setActiveTab] = useState('description');
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProduct = async (slug) => {
      try {
        console.log("slug=============",slug);
        console.log('Fetching product with slug:', slug); // Debug log
        const response = await getProductDetails(slug);
        console.log('API Response:', response); // Debug log

        if (response.success) {
          setProduct(response.data);
        } else {
          setError(response.message || 'Product not found');
        }
      } catch (err) {
        console.error('API Error:', err); // Debug log
        setError(err.message || 'Failed to fetch product');
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [slug]);

  const handleQuantityChange = (action) => {
    setQuantity((prevQuantity) => {
      if (action === 'increase') {
        return prevQuantity + 1;
      } else if (action === 'decrease' && prevQuantity > 1) {
        return prevQuantity - 1;
      }
      return prevQuantity;
    });
  };

  const handleTabChange = (tabName) => {
    setActiveTab(tabName);
  };

  if (loading) {
    return <div className="product-detail-page">Loading...</div>;
  }

  if (error) {
    return <div className="product-detail-page">Error: {error}</div>;
  }

  if (!product) {
    return <div className="product-detail-page">Product not found</div>;
  }

  return (
    <div className="product-detail-page">
      <header className="breadcrumb font-poppins">
        <nav>
          <a href="#">Home</a> &gt; <a href="#">{product.category}</a> &gt; <span>{product.brand}</span>
        </nav>
        <h1 className='product-heading'>{product.name}</h1>
        <p className="short-desc">
          {product.short_desc}
        </p>
      </header>

      <main className="main-content font-poppins">
        <section className="product-detail">
          <div className="product-media">
            <div className="product-image">
              <img src={product.image || "https://via.placeholder.com/600x400"} alt={product.name} />
            </div>
            <div className="product-actions">
              <button className="btn-icon">❤</button>
              <button className="btn-icon">⤴</button>
            </div>
          </div>

          <div className="product-info">
            <h1>{product.name}</h1>
            <div className="product-rating">
              <span className="stars">★★★★☆</span>
              <span className="rating-score">4.5 (25 reviews)</span>
            </div>
          </div>

          <aside className="product-sidebar font-poppins">
            <div className="sidebar-block">
              <label htmlFor="brand">Brand</label>
              <select id="brand">
                <option value={product.brand}>{product.brand}</option>
              </select>
            </div>

            <div className="sidebar-block">
              <label htmlFor="dimensions">Dimensions</label>
              <select id="dimensions">
                <option value={`${product.size}x${product.thickness}`}>
                  {product.size} x {product.thickness}
                </option>
              </select>
            </div>

            <div className="sidebar-block quantity-block">
              <label>Quantity</label>
              <div className="quantity-control">
                <button className="btn-qty minus" onClick={() => handleQuantityChange('decrease')}>-</button>
                <input type="text" value={quantity} className="qty-input" readOnly />
                <button className="btn-qty plus" onClick={() => handleQuantityChange('increase')}>+</button>
              </div>
            </div>

            <div className="sidebar-block">
              <label htmlFor="payment-term">Payment Term</label>
              <select id="payment-term">
                <option value="advance">Advance</option>
                <option value="cod">Cash on Delivery</option>
              </select>
            </div>

            <button className="btn btn-primary">Go to Cart</button>
          </aside>
        </section>

        <section className="tabs-section">
          <ul className="tab-nav">
            <li
              className={activeTab === 'description' ? 'active' : ''}
              onClick={() => handleTabChange('description')}
            >
              Description
            </li>
            <li
              className={activeTab === 'specification' ? 'active' : ''}
              onClick={() => handleTabChange('specification')}
            >
              Specification
            </li>
          </ul>

          <div className="tab-content">
            <div
              id="description"
              className={`tab-panel ${activeTab === 'description' ? 'active' : ''}`}
            >
              <div dangerouslySetInnerHTML={{ __html: product.description }} />
            </div>

            <div id="specification" className={`tab-panel ${activeTab === 'specification' ? 'active' : ''}`}>
              <table className="specification-table">
                <tbody>
                  <tr>
                    <td>Brand</td>
                    <td>{product.brand}</td>
                  </tr>
                  <tr>
                    <td>Grade</td>
                    <td>{product.grade}</td>
                  </tr>
                  <tr>
                    <td>Size</td>
                    <td>{product.size}</td>
                  </tr>
                  <tr>
                    <td>Thickness</td>
                    <td>{product.thickness}</td>
                  </tr>
                  <tr>
                    <td>Length</td>
                    <td>{product.length}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>

        <section className="recommended-section">
          <h2 className='recommend-heading'>Recommended</h2>
          <div className="recommended-grid">
            {[...Array(3)].map((_, idx) => (
              <div key={idx} className="recommended-card">
                <img src="https://via.placeholder.com/200" alt="Recommended Product" />
                <h3 className='brand-text'>Brand Name</h3>
                <p>
                  Lorem ipsum dolor sit amet.
                  <span className="icon-circle">
                    <FaArrowRight />
                  </span>
                </p>
              </div>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
};

export default ProductDetail;